import { render } from "./TrainingDetailsRelatedTrainings.vue?vue&type=template&id=6c2dd510"
import script from "./TrainingDetailsRelatedTrainings.vue?vue&type=script&lang=js"
export * from "./TrainingDetailsRelatedTrainings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__